import { format } from 'date-fns';

import { parseDate } from './parseDate';

/** conversion for legacy formats */
const dateFormatToDateFnsFormat = {
  DATE_FULL: 'MMMM d, yyyy',
  DATE_MED: 'MMM d, yyyy',
  a: 'yyyy-MM-dd'
};

export function formatDate(
  value: string | Date,
  dateFormat = 'M/d/yyyy'
): string {
  try {
    const date = parseDate(value) as Date;

    if (
      !date ||
      isNaN(date.valueOf()) ||
      (typeof value === 'string' &&
        !(value as string).includes((date as Date).getFullYear().toString()))
    ) {
      return value as string;
    }

    return format(date, dateFormatToDateFnsFormat[dateFormat] || dateFormat);
  } catch {
    return value as string;
  }
}
